import Card from 'Pages/Home/Components/Atoms/Card';
import Text from 'Pages/Home/Components/Atoms/Text';
import { useFetchSettingData } from 'Pages/Home/Hooks/useFetchSettingData';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';
import { Col, Row } from 'antd';
import React, { useMemo } from 'react';
import { getCloudImageUrl } from 'utils';
import { SUB_CATEGORY_DATA } from './Resources/Data';
import Styles from './SubCategorySection.module.scss';

const SubCategorySection: React.FC = () => {
  const { isMobileView } = useGetViewType();
  const { data: KAFairData } = useFetchSettingData('ka_fair_event');
  const { data: subCategoryData } = useFetchSettingData('subcategory_data');

  const s3BaseImageUrl = useMemo(() => {
    const orientationType = isMobileView ? 'portrait' : 'landscape';
    return `https://s3-ap-southeast-1.amazonaws.com/kickavenue.com/asset-images/subcategories/${orientationType}`;
  }, []);

  const MASTER_DATA = subCategoryData?.length>0? subCategoryData : SUB_CATEGORY_DATA;

  return (
    <div className={Styles['wrapper']}>
      <Row justify="space-between" gutter={16}>
        {MASTER_DATA.map((sub, index) => {
          const { redirectUrl, s3ImageName, ...props } = sub;
          sub.backgroundImage = getCloudImageUrl(
            `${s3BaseImageUrl}/${s3ImageName}`,
          );
          if (KAFairData.length) {
            const constructDataForKAFair = () => {
              if ([KAFairData, 'Daily Beaters'].includes(sub.title)) {
                sub.title = KAFairData;
                sub.backgroundImage = getCloudImageUrl(
                  `${s3BaseImageUrl}/event.png`,
                );
                sub.backgroundColor = '#29203c';
                sub.redirectUrl = 'sneakers';
                return;
              }

              if (sub.title === 'Under Retail') {
                sub.redirectUrl = 'collection/kick-avenue-fair-2022';
                return;
              }
              
              if(KAFairData.includes('Fair')) {
                if (['Kids/Toddler', 'KA Merchandise'].includes(sub.title)) {
                  sub.title = isMobileView ? 'Merchandise' : 'KA Merchandise';
                  sub.redirectUrl = 'collection/kick-avenue-fair-merch-2022';
                  sub.backgroundImage = getCloudImageUrl(
                    `${s3BaseImageUrl}/exclusive_merchandise.png`,
                  );
                  sub.extraBottomComponent = (
                    <Text
                      className={Styles['extra-bottom-component']}
                      variant="primary"
                    >
                      {isMobileView && 'Get More Tickets'}
                      {!isMobileView && 'Get More Tickets Here'}
                    </Text>
                  );
                }
              }
            };

            constructDataForKAFair();
          }

          const onClick = () => {
            window.open(`/${redirectUrl}`, '_blank');
          };

          return (
            <Col span={6} key={`sub-category-${index}`}>
              <Card.SubCategory useLink width={'100%'} {...props} link={redirectUrl}/>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default SubCategorySection;
